import { isNativeWebview } from '|/helpers/is-native-app';
import { MobileWebviewEvents } from '|/helpers/mobile-webview-events';
import sendNativeEvent from '|/helpers/send-native-event';

const useNavigateAwayFromPurchase = () => {
  if (isNativeWebview()) {
    return (path: string) => {
      sendNativeEvent({
        event: MobileWebviewEvents.CONTINUE_TO_SRP,
        url: path,
        source: 'purchase'
      });
    };
  }
  return (path: string) => {
    window.location.href = path;
  };
};

export default useNavigateAwayFromPurchase;
